export default __webpack_public_path__ + "static/media/element_spec_80.3c31c65b.webp";